import { Component, OnInit, Compiler, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';

import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { DOCUMENT } from '@angular/common';


import { UserService } from './shared';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  host: { 'window:beforeunload': 'doSomething' }
})
export class AppComponent implements OnInit {
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  currentUser: any;
  constructor(
    private userService: UserService,
    private _compiler: Compiler,
    private router: Router,
    public toastr: ToastsManager, vcr: ViewContainerRef,
    private idle: Idle, private keepalive: Keepalive
  ) {
    this._compiler.clearCache();
    if (window.location.href.indexOf('ResetPassword') == -1) {
      if (window.sessionStorage['loggedInUser'] == undefined &&  window.localStorage['currentUser'] != undefined) {
        this.userService.purgeAuth();
        this.router.navigate(['login']);
      }else{
        // this.router.navigate(['login']);
      }
    }

    idle.setIdle(300);
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    idle.setTimeout(5);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    idle.onIdleEnd.subscribe(() => {
      this.idleState = 'Session Time out.'
      this.toastr.warning('No longer idle.');
    });
    idle.onTimeout.subscribe(() => {
      var pathArray = window.location.href.split('/');
        if (this.contains(pathArray, "login") == true) {
        } else {
          this.idleState = 'Timed out.';
          this.toastr.warning('Timed out.');
          this.timedOut = true;
          this.router.navigate(['logout']);
          window.location.reload();
        }

    });
    idle.onIdleStart.subscribe(() => {
      // this.idleState = 'You\'ve gone idle.'
      var pathArray = window.location.href.split('/');
      if (this.contains(pathArray, "login") == true) {
        // !idle.watch();
      } else {
        this.toastr.warning('You\'ve gone idle');
      }
    });
    idle.onTimeoutWarning.subscribe((countdown) => {
      // this.idleState = 'You will time out in ' + countdown + ' seconds.'
      var pathArray = window.location.href.split('/');
      if (this.contains(pathArray, "login") == true) {
        // !idle.watch();
      } else {
        // this.toastr.info('You will time out in ' + countdown + ' seconds.');
      }
    });
    // sets the ping interval to 15 seconds
    keepalive.interval(15);
    keepalive.onPing.subscribe(() => this.lastPing = new Date());

    idle.watch();

  }


  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  ngOnInit() {
    this.userService.populate();
    this.userService.currentUser.subscribe(
      (userData): any => {
        this.currentUser = userData
      }
    )
  }

  isEmptyObject(obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }
    return true;
  }

  private contains(a, obj) {
    var i = a.length;
    while (i--) {
      if (a[i] === obj) {
        return true;
      }
    }
    return false;
  }


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts